import { ITestConfig } from "../../api/models/TestConfig"
import { TestConfigTableRow } from "../components/testConfig/TestConfigTable"

// Flattens a list of test configs, returning an object for each condition
// so each condition can be rendered as a table row
export const flattenTestConfig = (configs: ITestConfig[]): TestConfigTableRow[] => {
  return configs.flatMap<TestConfigTableRow>((config) => {
    return config.conditions.map((condition) => {
      const isNew = isNewTestConfig(config, condition)
      return {
        isNew,
        ...condition,
        ...config,
      }
    })
  })
}

export const isNewTestConfig = (
  testConfig: ITestConfig,
  condition: ITestConfig["conditions"][number],
): boolean => {
  // If the test config is the default or has an orgId, it is not new
  if (!testConfig.default || !!testConfig.orgId) return false

  // If it has the default data, it is new
  const hasDefaultConditionMessage = condition.message === "N/A"
  const hasDefaultThresholdValues = Object.values(condition.thresholds).every((t) => t === 0)
  if (hasDefaultConditionMessage && hasDefaultThresholdValues) return true

  return false
}
